import React, { useState, useEffect, useRef } from 'react';
import { setLoading, setSnackInfo } from '../../redux/actions/appAction';
import { connect } from 'react-redux';
import { useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import TableHead from '@material-ui/core/TableHead';
import { Button, CircularProgress, Grid, FormControl, InputLabel, Select, MenuItem, Box, Typography, Card, CardContent } from '@material-ui/core';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import FilterListIcon from '@material-ui/icons/FilterList';
import ClearIcon from '@material-ui/icons/Clear';
import EditIcon from '@material-ui/icons/Edit';
import CheckIcon from '@material-ui/icons/Check';
import RefreshIcon from '@material-ui/icons/Refresh';
import { RiFileExcel2Fill } from "react-icons/ri";
import * as XLSX from 'xlsx';
import HttpService from '../../services/httpService';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '20px',
    backgroundColor: '#f5f7fa',
    minHeight: '100vh',
  },
  title: {
    fontWeight: 700,
    color: '#1C375D',
    marginBottom: '24px',
    textAlign: 'center',
    fontSize: '28px',
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#1C375D',
    marginTop: '24px',
    marginBottom: '12px',
    padding: '10px 16px',
    backgroundColor: '#e8f0fe',
    borderRadius: '8px',
    borderLeft: '4px solid #1C375D',
  },
  subNote: {
    fontSize: '12px',
    color: 'white',
    fontStyle: 'bold',
    marginBottom: '12px',
    padding: '6px 10px',
    backgroundColor: '#1C375D',
    borderLeft: '3px solid #ff9800',
    borderRadius: '4px',
    fontWeight: 700,
  },
  tableContainer: {
    marginTop: '16px',
    marginBottom: '24px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: '#ffffff',
  },
  headerCell: {
    backgroundColor: '#1C375D',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '13px',
    padding: '10px 8px',
    borderRight: '1px solid rgba(255,255,255,0.2)',
    position: 'sticky',
    top: 0,
    textAlign: 'center',
    zIndex: 1,
  },
  tableheaderCell: {
    backgroundColor: '#1C375D',
    color: 'white',
    padding: '10px 8px',
    borderRight: '1px solid rgba(255,255,255,0.2)',
    position: 'sticky',
    top: 0,
    textAlign: 'center',
    zIndex: 2,
  },
  tableRowEven: {
    backgroundColor: '#ffffff',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
  tableRowOdd: {
    backgroundColor: '#f8f9fa',
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },
  grandTotalRow: {
    backgroundColor: '#e8f0fe',
    fontWeight: 'bold',
    '&:hover': {
      backgroundColor: '#d0e0fc',
    },
  },
  tablecell: {
    padding: '8px',
    borderRight: '1px solid #e0e0e0',
    color: '#263238',
    textAlign: 'center',
    fontSize: '12px',
  },
  clickableCount: {
    cursor: 'pointer',
    color: '#0d47a1',
    fontWeight: 'bold',
    textAlign: 'center',
    borderRight: '1px solid #e0e0e0',
    textDecoration: 'underline',
    '&:hover': {
      color: '#1565c0',
    },
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px',
  },
  downloadButton: {
    backgroundColor: "#355025",
    color: "#FFF2EB",
    '&:hover': {
      backgroundColor: "#2a401e",
    },
    '&.Mui-disabled': {
      backgroundColor: "#ccc",
      color: "#666",
    },
  },
  refreshButton: {
    backgroundColor: "#1C375D",
    color: "white",
    '&:hover': {
      backgroundColor: "#2a4a7a",
    },
  },
  summaryCard: {
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    padding: '16px',
    textAlign: 'center',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    transition: 'transform 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    },
  },
  summaryValue: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#1C375D',
  },
  summaryLabel: {
    fontSize: '12px',
    color: '#666',
    marginTop: '4px',
  },
  dialogPaper: {
    minWidth: '80%',
    maxWidth: '90%',
    height: '80vh',
    margin: '20px',
  },
  dialogTitle: {
    backgroundColor: '#1C375D',
    color: 'white',
    '& .MuiTypography-root': {
      fontWeight: 'bold',
    },
  },
  closeButton: {
    position: 'absolute',
    right: '10px',
    top: '10px',
    color: 'white',
  },
  dialogContent: {
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 40px)',
  },
  tableWrapper: {
    flex: 1,
    overflow: 'auto',
    marginBottom: '16px',
  },
  paginationWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 0',
    marginTop: 'auto',
  },
  amountCell: {
    fontWeight: 'bold',
    color: '#0d47a1',
    borderRight: '1px solid #e0e0e0',
  },
  editableDateContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '4px',
    flexWrap: 'wrap',
  },
  dateInput: {
    padding: '4px 8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '11px',
    width: '110px',
  },
  selectInput: {
    padding: '4px 8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '11px',
    width: '100px',
  },
  textInput: {
    padding: '4px 8px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '11px',
    width: '150px',
  },
  editButton: {
    padding: '2px',
  },
  filterContainer: {
    padding: '16px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    marginBottom: '16px',
    border: '1px solid #e0e0e0',
  },
  mainFilterContainer: {
    padding: '20px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    marginBottom: '24px',
    border: '1px solid #d0d7de',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
  },
  filterActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '16px',
    gap: '8px',
  },
  filterButton: {
    marginBottom: '10px',
    marginRight: '10px',
    backgroundColor: '#1C375D',
    color: 'white',
    '&:hover': {
      backgroundColor: '#2a4a7a',
    },
  },
  filterButtonOutline: {
    marginBottom: '10px',
    marginRight: '10px',
    borderColor: '#1C375D',
    color: '#1C375D',
  },
  projectLink: {
    color: '#0d47a1',
    textDecoration: 'underline',
    cursor: 'pointer',
    '&:hover': {
      color: '#1565c0',
    },
  },
}));

// Helper function to format amount in Lakhs/Crores
const formatAmount = (amount) => {
  if (!amount && amount !== 0) return '₹0';
  
  const numAmount = Number(amount);
  if (isNaN(numAmount)) return '₹0';
  
  if (numAmount >= 10000000) {
    const crores = numAmount / 10000000;
    return `₹${crores.toFixed(2)} Cr`;
  } else if (numAmount >= 100000) {
    const lakhs = numAmount / 100000;
    return `₹${lakhs.toFixed(2)} L`;
  } else if (numAmount >= 1000) {
    const thousands = numAmount / 1000;
    return `₹${thousands.toFixed(2)} K`;
  } else {
    return `₹${numAmount.toLocaleString()}`;
  }
};

// Helper function to download Excel
const downloadExcel = (data, headers, filename, mapper) => {
  const formattedData = data.map(mapper);
  const worksheetData = [headers, ...formattedData.map(row => headers.map(header => row[header]))];
  
  const ws = XLSX.utils.aoa_to_sheet(worksheetData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
  // Auto-size columns
  const colWidths = headers.map(header => ({ wch: Math.max(header.length, 15) }));
  ws['!cols'] = colWidths;
  
  XLSX.writeFile(wb, filename);
};

const ManagerDashboard = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector(state => state.user);
  const { setLoading, setSnackInfo } = props;

  // ==================== STATE DECLARATIONS ====================
  
  // Executive Summary States
  const [executiveSummaryData, setExecutiveSummaryData] = useState([]);
  const [filteredExecutiveSummaryData, setFilteredExecutiveSummaryData] = useState([]);
  const [executiveWorkStatusData, setExecutiveWorkStatusData] = useState([]);
  const [workStatusGrandTotals, setWorkStatusGrandTotals] = useState(null);
  const [filterOptions, setFilterOptions] = useState({
    executives: [],
    locations: []
  });
  
  // Main Filters - Date only (Location removed)
  const [mainFilters, setMainFilters] = useState({
    fromDate: '',
    toDate: ''
  });
  const [selectedExecutive, setSelectedExecutiveFilter] = useState('');
  const [tempFilters, setTempFilters] = useState({ fromDate: '', toDate: '' });

  // Table Data States
  const [idsoCount, setIdsoCount] = useState(0);
  const [idsoData, setIdsoData] = useState([]);
  const [dsoCount, setDsoCount] = useState(0);
  const [dsoData, setDsoData] = useState([]);
  const [paymentCount, setPaymentCount] = useState(0);
  const [paymentPopupCount, setPaymentPopupCount] = useState(0); // "Payment" metric-card popup only
  const [paymentPopupData, setPaymentPopupData] = useState([]); // "Payment" metric-card popup only
  const [paymentData, setPaymentData] = useState([]); // persistent, server-paginated "Payment Collected" table
  const [yesDsoData, setYesDsoData] = useState([]);
  const [secondDsoData, setSecondDsoData] = useState([]);
  const [thirdDsoData, setThirdDsoData] = useState([]);
  const [otherDsoData, setOtherDsoData] = useState([]); // NEW: Other DSO Data
  const [updatedPaymentData, setUpdatedPaymentData] = useState([]);

  // Loading States
  const [loading, setLoadingStates] = useState({
    summary: false,
    workStatus: false,
    idso: false,
    dso: false,
    paymentPopup: false, // "Payment" metric-card popup's own fetch
    payment: false, // persistent, server-paginated "Payment Collected" table's fetch
    yesDso: false,
    secondDso: false,
    thirdDso: false,
    otherDso: false, // NEW
    updatedPayment: false
  });

  // Pagination States for Tables
  const [yesDsoPage, setYesDsoPage] = useState(0);
  const [yesDsoRowsPerPage, setYesDsoRowsPerPage] = useState(10);
  const [secondDsoPage, setSecondDsoPage] = useState(0);
  const [secondDsoRowsPerPage, setSecondDsoRowsPerPage] = useState(10);
  const [thirdDsoPage, setThirdDsoPage] = useState(0);
  const [thirdDsoRowsPerPage, setThirdDsoRowsPerPage] = useState(10);
  const [otherDsoPage, setOtherDsoPage] = useState(0); // NEW
  const [otherDsoRowsPerPage, setOtherDsoRowsPerPage] = useState(10); // NEW
  const [paymentPage, setPaymentPage] = useState(0);
  const [paymentRowsPerPage, setPaymentRowsPerPage] = useState(10);
  const [updatedPaymentPage, setUpdatedPaymentPage] = useState(0);
  const [updatedPaymentRowsPerPage, setUpdatedPaymentRowsPerPage] = useState(10);

  // Filter Visibility States for other tables
  const [showYesDsoFilters, setShowYesDsoFilters] = useState(false);
  const [showSecondDsoFilters, setShowSecondDsoFilters] = useState(false);
  const [showThirdDsoFilters, setShowThirdDsoFilters] = useState(false);
  const [showOtherDsoFilters, setShowOtherDsoFilters] = useState(false); // NEW
  const [showPaymentFilters, setShowPaymentFilters] = useState(false);
  const [showUpdatedPaymentFilters, setShowUpdatedPaymentFilters] = useState(false);

  // Table Filter States (frontend filtering for tables)
  const [yesDsoFilters, setYesDsoFilters] = useState({
    projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: '', executiveName: ''
  });
  const [secondDsoFilters, setSecondDsoFilters] = useState({
    projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: '', startDate: '', endDate: '', executiveName: ''
  });
  const [thirdDsoFilters, setThirdDsoFilters] = useState({
    projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: '', executiveName: ''
  });
  const [otherDsoFilters, setOtherDsoFilters] = useState({ // NEW
    projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: '', executiveName: ''
  });
  const [paymentFilters, setPaymentFilters] = useState({
    projectNo: '', location: '', currentStage: '', executiveName: ''
  });
  const [updatedPaymentFilters, setUpdatedPaymentFilters] = useState({
    projectNo: '', location: '', currentStage: '', startDate: '', endDate: '', executiveName: ''
  });

 
  const [tableTotalCounts, setTableTotalCounts] = useState({
    yesDso: 0, secondDso: 0, thirdDso: 0, otherDso: 0, payment: 0, updatedPayment: 0
  });

 
  const [yesDsoDebouncedFilters, setYesDsoDebouncedFilters] = useState(yesDsoFilters);
  const [secondDsoDebouncedFilters, setSecondDsoDebouncedFilters] = useState(secondDsoFilters);
  const [thirdDsoDebouncedFilters, setThirdDsoDebouncedFilters] = useState(thirdDsoFilters);
  const [otherDsoDebouncedFilters, setOtherDsoDebouncedFilters] = useState(otherDsoFilters);
  const [paymentDebouncedFilters, setPaymentDebouncedFilters] = useState(paymentFilters);
  const [updatedPaymentDebouncedFilters, setUpdatedPaymentDebouncedFilters] = useState(updatedPaymentFilters);

 
  const [tableFilterOptionRows, setTableFilterOptionRows] = useState({
    yesDso: [], secondDso: [], thirdDso: [], otherDso: [], payment: [], updatedPayment: []
  });
  const mergeFilterOptionRows = (tableKey, rows) => {
    setTableFilterOptionRows(prev => {
      const seen = new Map(prev[tableKey].map(row => [row._id, row]));
      rows.forEach(row => seen.set(row._id, row));
      return { ...prev, [tableKey]: [...seen.values()].slice(-500) };
    });
  };

  // Guards each table's fetch against out-of-order responses — e.g. the initial unfiltered fetch
  // on mount is still in flight when the user picks a filter, and that older request happens to
  // resolve AFTER the new filtered one, silently overwriting the correct filtered rows with the
  // stale unfiltered ones. Each table increments its own counter before firing a request, and
  // only commits a response if it's still the most recent request for that table.
  const fetchSeqRef = useRef({ yesDso: 0, secondDso: 0, thirdDso: 0, otherDso: 0, payment: 0, updatedPayment: 0 });
  const nextFetchSeq = (tableKey) => ++fetchSeqRef.current[tableKey];
  const isLatestFetchSeq = (tableKey, seq) => fetchSeqRef.current[tableKey] === seq;

  // Dialog States
  const [showDetailsDialog, setShowDetailsDialog] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState(null);
  const [selectedExecutiveName, setSelectedExecutiveName] = useState(null);
  const [selectedMetricData, setSelectedMetricData] = useState([]);
  const [dialogPage, setDialogPage] = useState(0);
  const [dialogRowsPerPage, setDialogRowsPerPage] = useState(10);

  // Editable States for different fields
  const [editingCell, setEditingCell] = useState({ projectId: null, field: null });
  const [editValue, setEditValue] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);

  // Helper function to open project link in new tab
  const handleProjectClick = (projectId) => {
    window.open(`/project-logs/${projectId}`, '_blank');
  };


  // Patches one row's field, in place, across every table already loaded on screen — the edit is
  // reflected instantly without waiting on any network round trip, since we already know the new
  // value (we just set it).
  const patchRowLocally = (projectId, fieldName, value) => {
    const patch = (setter) => setter(prev => prev.map(row => (row._id === projectId ? { ...row, [fieldName]: value } : row)));
    patch(setYesDsoData);
    patch(setSecondDsoData);
    patch(setThirdDsoData);
    patch(setOtherDsoData);
    patch(setPaymentData);
    patch(setUpdatedPaymentData);
  };

  // Generic function to handle all updates
  const handleFieldUpdate = async (projectId, fieldName, value, tableKey) => {
    if (!value && value !== '') {
      props.setSnackInfo?.("Please enter a value", "warning");
      return;
    }

    setIsUpdating(true);
    try {
      const response = await HttpService.updatePaymentDate({
        leadId: projectId,
        fieldName: fieldName,
        value: value
      });

      if (response.success === true || response.status === 200) {
        // Reflect the new value immediately in every table that already holds this row.
        patchRowLocally(projectId, fieldName, value);
        props.setSnackInfo?.(`${fieldName} updated successfully`, "success");
        setEditingCell({ projectId: null, field: null });
        setEditValue('');

        // Refetch only the ONE table this edit was made in — not every table a bucket-defining
        // field (propertyPossession/hasKeys/materialDeliveryWilling) could theoretically move a
        // lead into, and not "Updated Payment Date" just because expectedPaymentDate changed.
        // If a lead does move DSO buckets as a result of this edit, the *other* bucket won't show
        // it until that table is itself next refreshed — a deliberate trade-off so committing an
        // edit only ever costs one table's fetch, not several.
        const tableFetchers = {
          yesDso: fetchYesDsoData,
          secondDso: fetchSecondDsoData,
          thirdDso: fetchThirdDsoData,
          otherDso: fetchOtherDsoData,
          payment: fetchPaymentTableData,
          updatedPayment: fetchUpdatedPaymentData
        };
        tableFetchers[tableKey]?.().catch(err => console.error(`Background ${tableKey} refresh failed:`, err));
      } else {
        props.setSnackInfo?.("Failed to update", "error");
      }
    } catch (error) {
      console.error('Error:', error);
      props.setSnackInfo?.("Error updating field", "error");
    } finally {
      setIsUpdating(false);
    }
  };

  // Editable Date Cell Component
  const EditableDateCell = ({ date, projectId, fieldName, label, tableKey }) => {
    const isEditing = editingCell.projectId === projectId && editingCell.field === fieldName;

    return (
      <div className={classes.editableDateContainer}>
        {isEditing ? (
          <>
            <input
              type="date"
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              disabled={isUpdating}
              className={classes.dateInput}
              autoFocus
            />
            <IconButton size="small" onClick={() => handleFieldUpdate(projectId, fieldName, editValue, tableKey)} disabled={isUpdating}>
              <CheckIcon style={{ fontSize: '14px', color: '#4caf50' }} />
            </IconButton>
            <IconButton size="small" onClick={() => { setEditingCell({ projectId: null, field: null }); setEditValue(''); }} disabled={isUpdating}>
              <CloseIcon style={{ fontSize: '14px', color: '#f44336' }} />
            </IconButton>
          </>
        ) : (
          <>
            <span>{date ? moment(date).format('DD-MM-YYYY') : 'Not Set'}</span>
            <IconButton 
              size="small" 
              onClick={() => { 
                setEditingCell({ projectId: projectId, field: fieldName }); 
                setEditValue(date ? moment(date).format('YYYY-MM-DD') : ''); 
              }}
            >
              <EditIcon style={{ fontSize: '14px', color: '#1C375D' }} />
            </IconButton>
          </>
        )}
      </div>
    );
  };

  // Editable Select Cell Component (for Possession Status & Key Status)
  const EditableSelectCell = ({ value, options, projectId, fieldName, label, tableKey }) => {
    const isEditing = editingCell.projectId === projectId && editingCell.field === fieldName;

    return (
      <div className={classes.editableDateContainer}>
        {isEditing ? (
          <>
            <select
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              disabled={isUpdating}
              className={classes.selectInput}
            >
              <option value="">Select</option>
              {options.map(opt => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
            <IconButton size="small" onClick={() => handleFieldUpdate(projectId, fieldName, editValue, tableKey)} disabled={isUpdating}>
              <CheckIcon style={{ fontSize: '14px', color: '#4caf50' }} />
            </IconButton>
            <IconButton size="small" onClick={() => { setEditingCell({ projectId: null, field: null }); setEditValue(''); }} disabled={isUpdating}>
              <CloseIcon style={{ fontSize: '14px', color: '#f44336' }} />
            </IconButton>
          </>
        ) : (
          <>
            <span>{value || 'Not Set'}</span>
            <IconButton 
              size="small" 
              onClick={() => { 
                setEditingCell({ projectId: projectId, field: fieldName }); 
                setEditValue(value || ''); 
              }}
            >
              <EditIcon style={{ fontSize: '14px', color: '#1C375D' }} />
            </IconButton>
          </>
        )}
      </div>
    );
  };

  // Editable Text Cell Component (for Remark)
  const EditableTextCell = ({ value, projectId, fieldName, label, tableKey }) => {
    const isEditing = editingCell.projectId === projectId && editingCell.field === fieldName;

    return (
      <div className={classes.editableDateContainer}>
        {isEditing ? (
          <>
            <input
              type="text"
              value={editValue}
              onChange={(e) => setEditValue(e.target.value)}
              disabled={isUpdating}
              className={classes.textInput}
              autoFocus
            />
            <IconButton size="small" onClick={() => handleFieldUpdate(projectId, fieldName, editValue, tableKey)} disabled={isUpdating}>
              <CheckIcon style={{ fontSize: '14px', color: '#4caf50' }} />
            </IconButton>
            <IconButton size="small" onClick={() => { setEditingCell({ projectId: null, field: null }); setEditValue(''); }} disabled={isUpdating}>
              <CloseIcon style={{ fontSize: '14px', color: '#f44336' }} />
            </IconButton>
          </>
        ) : (
          <>
            <span style={{ maxWidth: '150px', display: 'inline-block', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {value || 'Click to add remark'}
            </span>
            <IconButton 
              size="small" 
              onClick={() => { 
                setEditingCell({ projectId: projectId, field: fieldName }); 
                setEditValue(value || ''); 
              }}
            >
              <EditIcon style={{ fontSize: '14px', color: '#1C375D' }} />
            </IconButton>
          </>
        )}
      </div>
    );
  };

  // ==================== HELPER FUNCTIONS ====================

  const filterAndSortData = (data, filters, dateField = null) => {
    let filtered = [...data];
    
    if (filters.projectNo) {
      filtered = filtered.filter(item => 
        (item.erpProjectNo || '').toLowerCase().includes(filters.projectNo.toLowerCase())
      );
    }
    if (filters.location) {
      filtered = filtered.filter(item => (item?.cityName || '') === filters.location);
    }
    if (filters.currentStage) {
      filtered = filtered.filter(item => (item?.currentStage || '') === filters.currentStage);
    }
    if (filters.minDueAmount) {
      filtered = filtered.filter(item => parseFloat(item?.dueAmount || 0) >= parseFloat(filters.minDueAmount));
    }
    if (filters.maxDueAmount) {
      filtered = filtered.filter(item => parseFloat(item?.dueAmount || 0) <= parseFloat(filters.maxDueAmount));
    }
    if (filters.startDate && dateField) {
      filtered = filtered.filter(item => item[dateField] && moment(item[dateField]).isSameOrAfter(moment(filters.startDate)));
    }
    if (filters.endDate && dateField) {
      filtered = filtered.filter(item => item[dateField] && moment(item[dateField]).isSameOrBefore(moment(filters.endDate)));
    }
    if (filters.executiveName) {
      filtered = filtered.filter(item => (item?.crmUser?.name || item?.CrmUsersname || '') === filters.executiveName);
    }
    
    return filtered;
  };

  const getPaginatedData = (data, page, rowsPerPage) => {
    return data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  };

  // ==================== BACKEND API CALLS ====================

  // Fetch Executive Summary with filters (Date only)
  const fetchExecutiveSummary = async (filters = {}) => {
    setLoadingStates(prev => ({ ...prev, summary: true }));
    try {
      const requestFilters = {
        fromDate: filters.fromDate || mainFilters.fromDate,
        toDate: filters.toDate || mainFilters.toDate
      };
      
      const response = await HttpService.getRfdExecutiveSummary(requestFilters);
      if (response && response.status === 200) {
        setExecutiveSummaryData(response.data.data || []);
        setFilteredExecutiveSummaryData(response.data.data || []);
        const executives = [...new Set((response.data.data || []).map(item => item.executiveName))];
        setFilterOptions({
          executives: executives,
          locations: []
        });
      }
    } catch (error) {
      console.error('Error fetching executive summary:', error);
      props.setSnackInfo?.('Error loading executive summary', 'error');
    } finally {
      setLoadingStates(prev => ({ ...prev, summary: false }));
    }
  };

  // Apply filters on button click
  const applyFilters = () => {
    setMainFilters(tempFilters);
    fetchExecutiveSummary(tempFilters);
    setSelectedExecutiveFilter('');
  };

  // Filter executive summary by executive name
  const filterByExecutive = (executiveName) => {
    if (!executiveName) {
      setFilteredExecutiveSummaryData(executiveSummaryData);
    } else {
      const filtered = executiveSummaryData.filter(item => item.executiveName === executiveName);
      setFilteredExecutiveSummaryData(filtered);
    }
  };

  const handleExecutiveFilterChange = (value) => {
    setSelectedExecutiveFilter(value);
    filterByExecutive(value);
  };

  // Fetch Executive Work Status
  const fetchExecutiveWorkStatus = async () => {
    setLoadingStates(prev => ({ ...prev, workStatus: true }));
    try {
      const response = await HttpService.getRfdExecutiveWorkStatus();
      if (response && response.status === 200) {
        setExecutiveWorkStatusData(response.data.data || []);
        // Set grand totals from the response
        if (response.data.grandTotals) {
          setWorkStatusGrandTotals(response.data.grandTotals);
        } else if (response.data.summaryTotals) {
          setWorkStatusGrandTotals(response.data.summaryTotals);
        }
      }
    } catch (error) {
      console.error('Error fetching work status:', error);
      props.setSnackInfo?.('Error loading work status', 'error');
    } finally {
      setLoadingStates(prev => ({ ...prev, workStatus: false }));
    }
  };

  // Fetch IDSO Data
  const buildServerFilterParams = (filters) => ({
    projectNo: filters.projectNo,
    location: filters.location,
    currentStage: filters.currentStage,
    minDueAmount: filters.minDueAmount,
    maxDueAmount: filters.maxDueAmount,
    startDate: filters.startDate,
    endDate: filters.endDate,
    executiveName: filters.executiveName
  });

 
  const fetchIdsoData = async () => {
    setLoadingStates(prev => ({ ...prev, idso: true }));
    try {
      const response = await HttpService.IdsoCount({ limit: -1 });
      if (response?.status === 200) {
        const data = response?.data?.data || [];
        setIdsoCount(data.length);
        setIdsoData(data);
      }
    } catch (error) { console.error("Error fetching IDSO:", error); }
    finally { setLoadingStates(prev => ({ ...prev, idso: false })); }
  };

  // Fetch DSO Data
  const fetchDsoData = async () => {
    setLoadingStates(prev => ({ ...prev, dso: true }));
    try {
      const response = await HttpService.dsoCount({ limit: -1 });
      if (response?.status === 200) {
        const data = response?.data?.data || [];
        setDsoCount(data.length);
        setDsoData(data);
      }
    } catch (error) { console.error("Error fetching DSO:", error); }
    finally { setLoadingStates(prev => ({ ...prev, dso: false })); }
  };


  const fetchPaymentData = async () => {
    setLoadingStates(prev => ({ ...prev, paymentPopup: true }));
    try {
      const response = await HttpService.PaymentCollectedNotinUnderExecution({ limit: -1 });
      const data = response?.data?.data || [];
      setPaymentPopupCount(data.length);
      setPaymentPopupData(data);
    } catch (error) { console.error("Error fetching Payment:", error); }
    finally { setLoadingStates(prev => ({ ...prev, paymentPopup: false })); }
  };


  const fetchYesDsoData = async () => {
    const seq = nextFetchSeq('yesDso');
    setLoadingStates(prev => ({ ...prev, yesDso: true }));
    try {
      const response = await HttpService.DsoPaymentNotCollectedYesCondition({
        page: yesDsoPage + 1, limit: yesDsoRowsPerPage, ...buildServerFilterParams(yesDsoDebouncedFilters)
      });
      if (response?.status === 200 && isLatestFetchSeq('yesDso', seq)) {
        const data = response?.data?.data || [];
        setYesDsoData(data);
        setTableTotalCounts(prev => ({ ...prev, yesDso: response?.data?.totalCount || 0 }));
        mergeFilterOptionRows('yesDso', data);
      }
    } catch (error) { console.error("Error fetching Yes DSO:", error); }
    finally { if (isLatestFetchSeq('yesDso', seq)) setLoadingStates(prev => ({ ...prev, yesDso: false })); }
  };

  // Fetch Second DSO Data
  const fetchSecondDsoData = async () => {
    const seq = nextFetchSeq('secondDso');
    setLoadingStates(prev => ({ ...prev, secondDso: true }));
    try {
      const response = await HttpService.DsoPaymentNotCollectedSecondCondition({
        page: secondDsoPage + 1, limit: secondDsoRowsPerPage, ...buildServerFilterParams(secondDsoDebouncedFilters)
      });
      if (response?.status === 200 && isLatestFetchSeq('secondDso', seq)) {
        const data = response?.data?.data || [];
        setSecondDsoData(data);
        setTableTotalCounts(prev => ({ ...prev, secondDso: response?.data?.totalCount || 0 }));
        mergeFilterOptionRows('secondDso', data);
      }
    } catch (error) { console.error("Error fetching Second DSO:", error); }
    finally { if (isLatestFetchSeq('secondDso', seq)) setLoadingStates(prev => ({ ...prev, secondDso: false })); }
  };

  // Fetch Third DSO Data
  const fetchThirdDsoData = async () => {
    const seq = nextFetchSeq('thirdDso');
    setLoadingStates(prev => ({ ...prev, thirdDso: true }));
    try {
      const response = await HttpService.DsoPaymentNotCollectedThirdCondition({
        page: thirdDsoPage + 1, limit: thirdDsoRowsPerPage, ...buildServerFilterParams(thirdDsoDebouncedFilters)
      });
      if (response?.status === 200 && isLatestFetchSeq('thirdDso', seq)) {
        const data = response?.data?.data || [];
        setThirdDsoData(data);
        setTableTotalCounts(prev => ({ ...prev, thirdDso: response?.data?.totalCount || 0 }));
        mergeFilterOptionRows('thirdDso', data);
      }
    } catch (error) { console.error("Error fetching Third DSO:", error); }
    finally { if (isLatestFetchSeq('thirdDso', seq)) setLoadingStates(prev => ({ ...prev, thirdDso: false })); }
  };

  // NEW: Fetch Other DSO Data
  const fetchOtherDsoData = async () => {
    const seq = nextFetchSeq('otherDso');
    setLoadingStates(prev => ({ ...prev, otherDso: true }));
    try {
      const response = await HttpService.DsoPaymentNotCollectedOtherCondition({
        page: otherDsoPage + 1, limit: otherDsoRowsPerPage, ...buildServerFilterParams(otherDsoDebouncedFilters)
      });
      if (response?.status === 200 && isLatestFetchSeq('otherDso', seq)) {
        const data = response?.data?.data || [];
        setOtherDsoData(data);
        setTableTotalCounts(prev => ({ ...prev, otherDso: response?.data?.totalCount || 0 }));
        mergeFilterOptionRows('otherDso', data);
      }
    } catch (error) { console.error("Error fetching Other DSO:", error); }
    finally { if (isLatestFetchSeq('otherDso', seq)) setLoadingStates(prev => ({ ...prev, otherDso: false })); }
  };

  // Persistent "Payment Collected" table's own fetch (separate from fetchPaymentData's popup).
  const fetchPaymentTableData = async () => {
    const seq = nextFetchSeq('payment');
    setLoadingStates(prev => ({ ...prev, payment: true }));
    try {
      const response = await HttpService.PaymentCollectedNotinUnderExecution({
        page: paymentPage + 1, limit: paymentRowsPerPage, ...buildServerFilterParams(paymentDebouncedFilters)
      });
      if (response?.status === 200 && isLatestFetchSeq('payment', seq)) {
        const data = response?.data?.data || [];
        setPaymentData(data);
        setPaymentCount(response?.data?.totalCount || 0);
        setTableTotalCounts(prev => ({ ...prev, payment: response?.data?.totalCount || 0 }));
        mergeFilterOptionRows('payment', data);
      }
    } catch (error) { console.error("Error fetching Payment table data:", error); }
    finally { if (isLatestFetchSeq('payment', seq)) setLoadingStates(prev => ({ ...prev, payment: false })); }
  };

  // Fetch Updated Payment Data
  const fetchUpdatedPaymentData = async () => {
    const seq = nextFetchSeq('updatedPayment');
    setLoadingStates(prev => ({ ...prev, updatedPayment: true }));
    try {
      const response = await HttpService.getUpdatePaymentDate({
        page: updatedPaymentPage + 1, limit: updatedPaymentRowsPerPage, ...buildServerFilterParams(updatedPaymentDebouncedFilters)
      });
      if (response?.status === 200 && isLatestFetchSeq('updatedPayment', seq)) {
        const data = response?.data?.data || [];
        setUpdatedPaymentData(data);
        setTableTotalCounts(prev => ({ ...prev, updatedPayment: response?.data?.totalCount || 0 }));
        mergeFilterOptionRows('updatedPayment', data);
      }
    } catch (error) { console.error("Error fetching Updated Payment:", error); }
    finally { if (isLatestFetchSeq('updatedPayment', seq)) setLoadingStates(prev => ({ ...prev, updatedPayment: false })); }
  };


  useEffect(() => {
    const t = setTimeout(() => { setYesDsoDebouncedFilters(yesDsoFilters); setYesDsoPage(0); }, 400);
    return () => clearTimeout(t);
  }, [yesDsoFilters]);

  useEffect(() => {
    const t = setTimeout(() => { setSecondDsoDebouncedFilters(secondDsoFilters); setSecondDsoPage(0); }, 400);
    return () => clearTimeout(t);
  }, [secondDsoFilters]);

  useEffect(() => {
    const t = setTimeout(() => { setThirdDsoDebouncedFilters(thirdDsoFilters); setThirdDsoPage(0); }, 400);
    return () => clearTimeout(t);
  }, [thirdDsoFilters]);

  useEffect(() => {
    const t = setTimeout(() => { setOtherDsoDebouncedFilters(otherDsoFilters); setOtherDsoPage(0); }, 400);
    return () => clearTimeout(t);
  }, [otherDsoFilters]);

  useEffect(() => {
    const t = setTimeout(() => { setPaymentDebouncedFilters(paymentFilters); setPaymentPage(0); }, 400);
    return () => clearTimeout(t);
  }, [paymentFilters]);

  useEffect(() => {
    const t = setTimeout(() => { setUpdatedPaymentDebouncedFilters(updatedPaymentFilters); setUpdatedPaymentPage(0); }, 400);
    return () => clearTimeout(t);
  }, [updatedPaymentFilters]);

  // The 6 persistent tables: (re)fetch whenever that table's page, page size, or debounced
  // filters change — this also covers the very first fetch on mount.
  useEffect(() => { fetchYesDsoData(); /* eslint-disable-next-line */ }, [yesDsoPage, yesDsoRowsPerPage, yesDsoDebouncedFilters]);
  useEffect(() => { fetchSecondDsoData(); /* eslint-disable-next-line */ }, [secondDsoPage, secondDsoRowsPerPage, secondDsoDebouncedFilters]);
  useEffect(() => { fetchThirdDsoData(); /* eslint-disable-next-line */ }, [thirdDsoPage, thirdDsoRowsPerPage, thirdDsoDebouncedFilters]);
  useEffect(() => { fetchOtherDsoData(); /* eslint-disable-next-line */ }, [otherDsoPage, otherDsoRowsPerPage, otherDsoDebouncedFilters]);
  useEffect(() => { fetchPaymentTableData(); /* eslint-disable-next-line */ }, [paymentPage, paymentRowsPerPage, paymentDebouncedFilters]);
  useEffect(() => { fetchUpdatedPaymentData(); /* eslint-disable-next-line */ }, [updatedPaymentPage, updatedPaymentRowsPerPage, updatedPaymentDebouncedFilters]);

  // Handle Filter Changes for Date (Temp storage)
  const handleTempFilterChange = (filterName, value) => {
    setTempFilters({ ...tempFilters, [filterName]: value });
  };

  const clearMainFilters = () => {
    setTempFilters({ fromDate: '', toDate: '' });
    setMainFilters({ fromDate: '', toDate: '' });
    setSelectedExecutiveFilter('');
    fetchExecutiveSummary({ fromDate: '', toDate: '' });
  };

  // Handle Drill-Down Click for Executive Summary Counts
  const handleSummaryCountClick = async (executiveName, metricType, rowData) => {
    setSelectedExecutiveName(executiveName);
    setSelectedMetric(metricType);
    setShowDetailsDialog(true);
    setDialogPage(0);
    
    try {
      let data = [];
      if (metricType === "Total Projects (DSO Payment Not Collected)") {
        data = rowData?.projectsData || [];
      } else if (metricType === "Payment Collected Not in Under Execution") {
        data = rowData?.paymentData || [];
      }
      setSelectedMetricData(data);
    } catch (error) {
      console.error('Error fetching projects:', error);
      props.setSnackInfo?.('Error loading project details', 'error');
    }
  };

  // Handle Drill-Down Click for Executive Work Status
  const handleWorkStatusClick = async (executiveName, metricType, rowData) => {
    setSelectedExecutiveName(executiveName);
    setSelectedMetric(metricType);
    setShowDetailsDialog(true);
    setDialogPage(0);
    
    try {
      let data = [];
      if (metricType === "Assigned Projects") {
        data = rowData?.yesterdaySignoffData || [];
      } else if (metricType === "Pending Projects") {
        data = rowData?.pendingProjectsData || [];
      } else if (metricType === "Today's Due Amount") {
        data = rowData?.todayDueData || [];
      } else if (metricType === "Today's Collected Amount") {
        data = rowData?.todayCollectedData || [];
      }
      setSelectedMetricData(data);
    } catch (error) {
      console.error('Error fetching work status details:', error);
      props.setSnackInfo?.('Error loading details', 'error');
    }
  };

  // Handle Stats Card Click
  const handleCardClick = async (type, metricName) => {
    setSelectedMetric(metricName);
    setSelectedExecutiveName(null);
    setShowDetailsDialog(true);
    setDialogPage(0);
    
    let data = [];
    if (type === "idso") data = idsoData;
    else if (type === "dso") data = dsoData;
    else if (type === "payment") data = paymentPopupData;
    setSelectedMetricData(data);
  };

  // Dialog Functions
  const handleDialogDownload = () => {
    let excelData = [];
    let filename = "";
    
    if (selectedMetric === "Total Projects (DSO Payment Not Collected)" || selectedMetric === "DSO Payment Not Collected") {
      filename = "dso-payment-not-collected.xlsx";
      const headers = ["S.No", "Project No", "Client Name", "Contact", "Location", "Current Stage", "Design SignOff Date", "Due Amount", "Executive Name"];
      excelData = selectedMetricData.map((item, idx) => ({
        "S.No": idx + 1, 
        "Project No": item.erpProjectNo || "NA", 
        "Client Name": item?.customer?.name || "NA",
        // "Contact": item?.customer?.contact_no || "NA", 
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA", 
        "Design SignOff Date": item?.designSignOffDate ? moment(item.designSignOffDate).format('DD-MM-YYYY') : 
                             item?.movedToImosDate ? moment(item.movedToImosDate).format('DD-MM-YYYY') : 'NA',
        "Due Amount": formatAmount(item?.dueAmount || 0),
        "Executive Name": item?.crmUser?.name || item?.CrmUsersname || 'NA',
      }));
      downloadExcel(excelData, headers, filename, (row) => row);
    } else if (selectedMetric === "Payment Collected Not in Under Execution" || selectedMetric === "Payment Collected") {
      filename = "payment-collected.xlsx";
      const headers = ["S.No", "Project No", "Client Name", "Contact", "Location", "Current Stage", "Design SignOff Date", "Collected Amount", "Executive Name"];
      excelData = selectedMetricData.map((item, idx) => ({
        "S.No": idx + 1, 
        "Project No": item.erpProjectNo || "NA", 
        "Client Name": item?.customer?.name || "NA",
        // "Contact": item?.customer?.contact_no || "NA", 
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA", 
        "Design SignOff Date": item?.designSignOffDate ? moment(item.designSignOffDate).format('DD-MM-YYYY') : 
                             item?.movedToImosDate ? moment(item.movedToImosDate).format('DD-MM-YYYY') : 'NA',
        "Collected Amount": formatAmount(item?.collectedAmount || 0),
        "Executive Name": item?.crmUser?.name || item?.CrmUsersname || 'NA',
      }));
      downloadExcel(excelData, headers, filename, (row) => row);
    } else if (selectedMetric === "Assigned Projects") {
      filename = "yesterday-signoff-projects.xlsx";
      const headers = ["S.No", "Project No", "Client Name", "Contact", "Location", "Current Stage", "SignOff Date", "Due Amount"];
      excelData = selectedMetricData.map((item, idx) => ({
        "S.No": idx + 1, 
        "Project No": item.erpProjectNo || "NA", 
        "Client Name": item?.customer?.name || "NA",
        // "Contact": item?.customer?.contact_no || "NA", 
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA", 
        "SignOff Date": item?.customerDesignSignOffDate ? moment(item.customerDesignSignOffDate).format('DD-MM-YYYY') : 'NA',
        "Due Amount": formatAmount(item?.dueAmount || 0),
      }));
      downloadExcel(excelData, headers, filename, (row) => row);
    } else if (selectedMetric === "Pending Projects") {
      filename = "pending-projects.xlsx";
      const headers = ["S.No", "Project No", "Client Name", "Contact", "Location", "Current Stage", "Total Amount", "Paid Amount", "Due Amount"];
      excelData = selectedMetricData.map((item, idx) => ({
        "S.No": idx + 1, 
        "Project No": item.erpProjectNo || "NA", 
        "Client Name": item?.customer?.name || "NA",
        // "Contact": item?.customer?.contact_no || "NA", 
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA", 
        "Total Amount": formatAmount(item?.grandTotal || 0),
        "Paid Amount": formatAmount(item?.totalPaid || 0),
        "Due Amount": formatAmount(item?.dueAmount || 0),
      }));
      downloadExcel(excelData, headers, filename, (row) => row);
    } else if (selectedMetric === "Today's Due Amount") {
      filename = "todays-due-amount.xlsx";
      const headers = ["S.No", "Project No", "Client Name", "Contact", "Location", "Current Stage", "Expected Payment Date", "Material Delivery Date", "Due Amount"];
      excelData = selectedMetricData.map((item, idx) => ({
        "S.No": idx + 1, 
        "Project No": item.erpProjectNo || "NA", 
        "Client Name": item?.customer?.name || "NA",
        // "Contact": item?.customer?.contact_no || "NA", 
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA", 
        "Expected Payment Date": item?.expectedPaymentDate ? moment(item.expectedPaymentDate).format('DD-MM-YYYY') : 'NA',
        "Material Delivery Date": item?.materialDeliveryDate || 'NA',
        "Due Amount": formatAmount(item?.dueAmount || 0),
      }));
      downloadExcel(excelData, headers, filename, (row) => row);
    } else if (selectedMetric === "Today's Collected Amount") {
      filename = "todays-collected-amount.xlsx";
      const headers = ["S.No", "Project No", "Client Name", "Contact", "Location", "Current Stage", "Collected Amount"];
      excelData = selectedMetricData.map((item, idx) => ({
        "S.No": idx + 1, 
        "Project No": item.erpProjectNo || "NA", 
        "Client Name": item?.customer?.name || "NA",
        // "Contact": item?.customer?.contact_no || "NA", 
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA", 
        "Collected Amount": formatAmount(item?.collectedAmount || 0),
      }));
      downloadExcel(excelData, headers, filename, (row) => row);
    } else if (selectedMetric === "IDSO") {
      filename = "idso-data.xlsx";
      const headers = ["S.No", "Project No", "Client Name", "Contact", "Location", "Current Stage", "Executive Name"];
      excelData = selectedMetricData.map((item, idx) => ({
        "S.No": idx + 1, 
        "Project No": item.erpProjectNo || "NA", 
        "Client Name": item?.customerId?.name || "NA",
        "Contact": item?.customerId?.contact_no || "NA", 
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA",
        "Executive Name": item?.crmUser?.name || item?.CrmUsersname || 'NA',
      }));
      downloadExcel(excelData, headers, filename, (row) => row);
    } else if (selectedMetric === "DSO") {
      filename = "dso-data.xlsx";
      const headers = ["S.No", "Project No", "Client Name", "Contact", "Location", "Current Stage", "Due Amount", "Executive Name"];
      excelData = selectedMetricData.map((item, idx) => ({
        "S.No": idx + 1, 
        "Project No": item.erpProjectNo || "NA", 
        "Client Name": item?.customer?.name || "NA",
        // "Contact": item?.customer?.contact_no || "NA", 
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA", 
        "Due Amount": formatAmount(item?.dueAmount || 0),
        "Executive Name": item?.crmUser?.name || item?.CrmUsersname || 'NA',
      }));
      downloadExcel(excelData, headers, filename, (row) => row);
    }
  };

  const handleCloseDialog = () => {
    setShowDetailsDialog(false);
    setSelectedMetric(null);
    setSelectedMetricData([]);
    setSelectedExecutiveName(null);
    setDialogPage(0);
  };

  // Dialog Content Renderer
  const renderDialogContent = () => {
    const paginatedData = getPaginatedData(selectedMetricData, dialogPage, dialogRowsPerPage);

    if (selectedMetric === "Total Projects (DSO Payment Not Collected)" || selectedMetric === "DSO Payment Not Collected") {
      return (
        <div className={classes.tableWrapper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>S.No</TableCell>
                <TableCell className={classes.headerCell}>Project No</TableCell>
                <TableCell className={classes.headerCell}>Client Name</TableCell>
                <TableCell className={classes.headerCell}>Contact</TableCell>
                <TableCell className={classes.headerCell}>Location</TableCell>
                <TableCell className={classes.headerCell}>Current Stage</TableCell>
                <TableCell className={classes.headerCell}>Design SignOff Date</TableCell>
                <TableCell className={classes.headerCell}>Due Amount</TableCell>
                <TableCell className={classes.headerCell}>Executive Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, idx) => (
                <TableRow key={row._id || idx}>
                  <TableCell className={classes.tablecell}>{dialogPage * dialogRowsPerPage + idx + 1}</TableCell>
                  <TableCell className={classes.tablecell}>
                    <span 
                      className={classes.projectLink}
                      onClick={() => handleProjectClick(row?._id)}
                    >
                      {row?.erpProjectNo || 'NA'}
                    </span>
                  </TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.name || row?.customerId?.name || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.contact_no || row?.customerId?.contact_no || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>
                    {row?.designSignOffDate ? moment(row.designSignOffDate).format('DD-MM-YYYY') : 
                     row?.customerDesignSignOffDate ? moment(row.customerDesignSignOffDate).format('DD-MM-YYYY') : 'NA'}
                  </TableCell>
                  <TableCell className={classes.amountCell}>{formatAmount(row?.dueAmount || 0)}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.crmUser?.name || row?.CrmUsersname || 'NA'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    } else if (selectedMetric === "Payment Collected Not in Under Execution" || selectedMetric === "Payment Collected") {
      return (
        <div className={classes.tableWrapper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>S.No</TableCell>
                <TableCell className={classes.headerCell}>Project No</TableCell>
                <TableCell className={classes.headerCell}>Client Name</TableCell>
                <TableCell className={classes.headerCell}>Contact</TableCell>
                <TableCell className={classes.headerCell}>Location</TableCell>
                <TableCell className={classes.headerCell}>Current Stage</TableCell>
                <TableCell className={classes.headerCell}>Design SignOff Date</TableCell>
                <TableCell className={classes.headerCell}>Collected Amount</TableCell>
                <TableCell className={classes.headerCell}>Executive Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, idx) => (
                <TableRow key={row._id || idx}>
                  <TableCell className={classes.tablecell}>{dialogPage * dialogRowsPerPage + idx + 1}</TableCell>
                  <TableCell className={classes.tablecell}>
                    <span 
                      className={classes.projectLink}
                      onClick={() => handleProjectClick(row?._id)}
                    >
                      {row?.erpProjectNo || 'NA'}
                    </span>
                  </TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.name || row?.customerId?.name || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.contact_no || row?.customerId?.contact_no || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>
                    {row?.designSignOffDate ? moment(row.designSignOffDate).format('DD-MM-YYYY') : 
                     row?.customerDesignSignOffDate ? moment(row.customerDesignSignOffDate).format('DD-MM-YYYY') : 'NA'}
                  </TableCell>
                  <TableCell className={classes.amountCell}>{formatAmount(row?.collectedAmount || 0)}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.crmUser?.name || row?.CrmUsersname || 'NA'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    } else if (selectedMetric === "Assigned Projects") {
      return (
        <div className={classes.tableWrapper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>S.No</TableCell>
                <TableCell className={classes.headerCell}>Project No</TableCell>
                <TableCell className={classes.headerCell}>Client Name</TableCell>
                <TableCell className={classes.headerCell}>Contact</TableCell>
                <TableCell className={classes.headerCell}>Location</TableCell>
                <TableCell className={classes.headerCell}>Current Stage</TableCell>
                <TableCell className={classes.headerCell}>SignOff Date</TableCell>
                <TableCell className={classes.headerCell}>Due Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, idx) => (
                <TableRow key={row._id || idx}>
                  <TableCell className={classes.tablecell}>{dialogPage * dialogRowsPerPage + idx + 1}</TableCell>
                  <TableCell className={classes.tablecell}>
                    <span 
                      className={classes.projectLink}
                      onClick={() => handleProjectClick(row?._id)}
                    >
                      {row?.erpProjectNo || 'NA'}
                    </span>
                  </TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.name || row?.customerId?.name || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.contact_no || row?.customerId?.contact_no || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>
                    {row?.customerDesignSignOffDate ? moment(row.customerDesignSignOffDate).format('DD-MM-YYYY') : 'NA'}
                  </TableCell>
                  <TableCell className={classes.amountCell}>{formatAmount(row?.dueAmount || 0)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    } else if (selectedMetric === "Pending Projects") {
      return (
        <div className={classes.tableWrapper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>S.No</TableCell>
                <TableCell className={classes.headerCell}>Project No</TableCell>
                <TableCell className={classes.headerCell}>Client Name</TableCell>
                <TableCell className={classes.headerCell}>Contact</TableCell>
                <TableCell className={classes.headerCell}>Location</TableCell>
                <TableCell className={classes.headerCell}>Current Stage</TableCell>
                <TableCell className={classes.headerCell}>Total Amount</TableCell>
                <TableCell className={classes.headerCell}>Paid Amount</TableCell>
                <TableCell className={classes.headerCell}>Due Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, idx) => (
                <TableRow key={row._id || idx}>
                  <TableCell className={classes.tablecell}>{dialogPage * dialogRowsPerPage + idx + 1}</TableCell>
                  <TableCell className={classes.tablecell}>
                    <span 
                      className={classes.projectLink}
                      onClick={() => handleProjectClick(row?._id)}
                    >
                      {row?.erpProjectNo || 'NA'}
                    </span>
                  </TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.name || row?.customerId?.name || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.contact_no || row?.customerId?.contact_no || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                  <TableCell className={classes.amountCell}>{formatAmount(row?.grandTotal || 0)}</TableCell>
                  <TableCell className={classes.amountCell}>{formatAmount(row?.totalPaid || 0)}</TableCell>
                  <TableCell className={classes.amountCell}>{formatAmount(row?.dueAmount || 0)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    } else if (selectedMetric === "Today's Due Amount") {
      return (
        <div className={classes.tableWrapper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>S.No</TableCell>
                <TableCell className={classes.headerCell}>Project No</TableCell>
                <TableCell className={classes.headerCell}>Client Name</TableCell>
                <TableCell className={classes.headerCell}>Contact</TableCell>
                <TableCell className={classes.headerCell}>Location</TableCell>
                <TableCell className={classes.headerCell}>Current Stage</TableCell>
                <TableCell className={classes.headerCell}>Expected Payment Date</TableCell>
                <TableCell className={classes.headerCell}>Payment Material Delivery Date</TableCell>
                <TableCell className={classes.headerCell}>Due Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, idx) => (
                <TableRow key={row._id || idx}>
                  <TableCell className={classes.tablecell}>{dialogPage * dialogRowsPerPage + idx + 1}</TableCell>
                  <TableCell className={classes.tablecell}>
                    <span 
                      className={classes.projectLink}
                      onClick={() => handleProjectClick(row?._id)}
                    >
                      {row?.erpProjectNo || 'NA'}
                    </span>
                  </TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.name || row?.customerId?.name || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.contact_no || row?.customerId?.contact_no || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>
                    {row?.expectedPaymentDate ? moment(row.expectedPaymentDate).format('DD-MM-YYYY') : 'NA'}
                  </TableCell>
                  <TableCell className={classes.tablecell}>{row?.materialDeliveryDate || 'NA'}</TableCell>
                  <TableCell className={classes.amountCell}>{formatAmount(row?.dueAmount || 0)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    } else if (selectedMetric === "Today's Collected Amount") {
      return (
        <div className={classes.tableWrapper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>S.No</TableCell>
                <TableCell className={classes.headerCell}>Project No</TableCell>
                <TableCell className={classes.headerCell}>Client Name</TableCell>
                <TableCell className={classes.headerCell}>Contact</TableCell>
                <TableCell className={classes.headerCell}>Location</TableCell>
                <TableCell className={classes.headerCell}>Current Stage</TableCell>
                <TableCell className={classes.headerCell}>Collected Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, idx) => (
                <TableRow key={row._id || idx}>
                  <TableCell className={classes.tablecell}>{dialogPage * dialogRowsPerPage + idx + 1}</TableCell>
                  <TableCell className={classes.tablecell}>
                    <span 
                      className={classes.projectLink}
                      onClick={() => handleProjectClick(row?._id)}
                    >
                      {row?.erpProjectNo || 'NA'}
                    </span>
                  </TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.name || row?.customerId?.name || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.contact_no || row?.customerId?.contact_no || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                  <TableCell className={classes.amountCell}>{formatAmount(row?.collectedAmount || 0)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    } else if (selectedMetric === "IDSO") {
      return (
        <div className={classes.tableWrapper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>S.No</TableCell>
                <TableCell className={classes.headerCell}>Project No</TableCell>
                <TableCell className={classes.headerCell}>Client Name</TableCell>
                <TableCell className={classes.headerCell}>Contact</TableCell>
                <TableCell className={classes.headerCell}>Location</TableCell>
                <TableCell className={classes.headerCell}>Current Stage</TableCell>
                <TableCell className={classes.headerCell}>Executive Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, idx) => (
                <TableRow key={row._id || idx}>
                  <TableCell className={classes.tablecell}>{dialogPage * dialogRowsPerPage + idx + 1}</TableCell>
                  <TableCell className={classes.tablecell}>
                    <span 
                      className={classes.projectLink}
                      onClick={() => handleProjectClick(row?._id)}
                    >
                      {row?.erpProjectNo || 'NA'}
                    </span>
                  </TableCell>
                  <TableCell className={classes.tablecell}>{row?.customerId?.name || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.customerId?.contact_no || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.crmUser?.name || row?.CrmUsersname || 'NA'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    } else if (selectedMetric === "DSO") {
      return (
        <div className={classes.tableWrapper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell className={classes.headerCell}>S.No</TableCell>
                <TableCell className={classes.headerCell}>Project No</TableCell>
                <TableCell className={classes.headerCell}>Client Name</TableCell>
                <TableCell className={classes.headerCell}>Contact</TableCell>
                <TableCell className={classes.headerCell}>Location</TableCell>
                <TableCell className={classes.headerCell}>Current Stage</TableCell>
                <TableCell className={classes.headerCell}>Due Amount</TableCell>
                <TableCell className={classes.headerCell}>Executive Name</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedData.map((row, idx) => (
                <TableRow key={row._id || idx}>
                  <TableCell className={classes.tablecell}>{dialogPage * dialogRowsPerPage + idx + 1}</TableCell>
                  <TableCell className={classes.tablecell}>
                    <span 
                      className={classes.projectLink}
                      onClick={() => handleProjectClick(row?._id)}
                    >
                      {row?.erpProjectNo || 'NA'}
                    </span>
                  </TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.name || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.customer?.contact_no || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                  <TableCell className={classes.amountCell}>{formatAmount(row?.dueAmount || 0)}</TableCell>
                  <TableCell className={classes.tablecell}>{row?.crmUser?.name || row?.CrmUsersname || 'NA'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    }
    return null;
  };

  // Clear Filter Functions for other tables
  const clearYesDsoFilters = () => setYesDsoFilters({ projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: '', executiveName: '' });
  const clearSecondDsoFilters = () => setSecondDsoFilters({ projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: '', startDate: '', endDate: '', executiveName: '' });
  const clearThirdDsoFilters = () => setThirdDsoFilters({ projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: '', executiveName: '' });
  const clearOtherDsoFilters = () => setOtherDsoFilters({ projectNo: '', location: '', currentStage: '', minDueAmount: '', maxDueAmount: '', executiveName: '' }); // NEW
  const clearPaymentFilters = () => setPaymentFilters({ projectNo: '', location: '', currentStage: '', executiveName: '' });
  const clearUpdatedPaymentFilters = () => setUpdatedPaymentFilters({ projectNo: '', location: '', currentStage: '', startDate: '', endDate: '', executiveName: '' });

  const renderFilterToggle = (show, setShow, label) => (
    <Button size="small" variant="outlined" startIcon={<FilterListIcon />} onClick={() => setShow(!show)} className={classes.filterButtonOutline}>
      {show ? 'Hide' : 'Show'} {label} Filters
    </Button>
  );

  useEffect(() => {
    setTempFilters({ fromDate: '', toDate: '' });
    fetchExecutiveSummary(mainFilters);
    fetchExecutiveWorkStatus();
    fetchIdsoData();
    fetchDsoData();
    fetchPaymentData();
  }, []);


  const filteredExecutiveWorkStatusData = selectedExecutive
    ? executiveWorkStatusData.filter(item => item.executiveName === selectedExecutive)
    : executiveWorkStatusData;

  const filteredYesDso = yesDsoData;
  const filteredSecondDso = secondDsoData;
  const filteredThirdDso = thirdDsoData;
  const filteredOtherDso = otherDsoData;
  const filteredPayment = paymentData;
  const filteredUpdatedPayment = updatedPaymentData;

  // Refresh All Data
  const refreshAllData = () => {
    fetchExecutiveSummary(mainFilters);
    fetchExecutiveWorkStatus();
    fetchIdsoData();
    fetchDsoData();
    fetchPaymentData();
    fetchYesDsoData();
    fetchSecondDsoData();
    fetchThirdDsoData();
    fetchOtherDsoData(); // NEW
    fetchPaymentTableData();
    fetchUpdatedPaymentData();
    props.setSnackInfo?.("Data refreshed successfully", "success");
  };

  // Pagination Handlers
  const handleYesDsoPageChange = (e, p) => setYesDsoPage(p);
  const handleYesDsoRowsPerPageChange = (e) => { setYesDsoRowsPerPage(parseInt(e.target.value)); setYesDsoPage(0); };
  const handleSecondDsoPageChange = (e, p) => setSecondDsoPage(p);
  const handleSecondDsoRowsPerPageChange = (e) => { setSecondDsoRowsPerPage(parseInt(e.target.value)); setSecondDsoPage(0); };
  const handleThirdDsoPageChange = (e, p) => setThirdDsoPage(p);
  const handleThirdDsoRowsPerPageChange = (e) => { setThirdDsoRowsPerPage(parseInt(e.target.value)); setThirdDsoPage(0); };
  const handleOtherDsoPageChange = (e, p) => setOtherDsoPage(p); // NEW
  const handleOtherDsoRowsPerPageChange = (e) => { setOtherDsoRowsPerPage(parseInt(e.target.value)); setOtherDsoPage(0); }; // NEW
  const handlePaymentPageChange = (e, p) => setPaymentPage(p);
  const handlePaymentRowsPerPageChange = (e) => { setPaymentRowsPerPage(parseInt(e.target.value)); setPaymentPage(0); };
  const handleUpdatedPaymentPageChange = (e, p) => setUpdatedPaymentPage(p);
  const handleUpdatedPaymentRowsPerPageChange = (e) => { setUpdatedPaymentRowsPerPage(parseInt(e.target.value)); setUpdatedPaymentPage(0); };


  const handleYesDsoExcelDownload = async () => {
    setLoading(true);
    try {
      const response = await HttpService.DsoPaymentNotCollectedYesCondition({ limit: -1, ...buildServerFilterParams(yesDsoDebouncedFilters) });
      const headers = ["S.No", "Project No", "Client Name", "Contact", "Location", "Current Stage", "Design SignOff Date", "Due Amount", "Expected Payment Date", "Executive Name"];
      const data = (response?.data?.data || []).map((item, idx) => ({
        "S.No": idx + 1,
        "Project No": item.erpProjectNo || "NA",
        "Client Name": item?.customer?.name || "NA",
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA",
        "Design SignOff Date": item?.customerDesignSignOffDate ? moment(item.customerDesignSignOffDate).format('DD-MM-YYYY') : "NA",
        "Due Amount": formatAmount(item?.dueAmount || 0),
        "Expected Payment Date": item?.expectedPaymentDate ? moment(item.expectedPaymentDate).format('DD-MM-YYYY') : "NA",
        "Executive Name": item?.crmUser?.name || item?.CrmUsersname || 'NA',
      }));
      downloadExcel(data, headers, "dso-yes-condition.xlsx", (row) => row);
    } catch (error) {
      console.error("Error downloading Yes DSO Excel:", error);
      props.setSnackInfo?.("Couldn't prepare Excel export", "error");
    }
    setLoading(false);
  };

  const handleSecondDsoExcelDownload = async () => {
    setLoading(true);
    try {
      const response = await HttpService.DsoPaymentNotCollectedSecondCondition({ limit: -1, ...buildServerFilterParams(secondDsoDebouncedFilters) });
      const headers = ["S.No", "Project No", "Client Name", "Contact", "Location", "Current Stage", "Design SignOff Date", "Due Amount", "Possession Status", "Possession Date", "Key Status", "Expected Payment Date", "Executive Name"];
      const data = (response?.data?.data || []).map((item, idx) => ({
        "S.No": idx + 1,
        "Project No": item.erpProjectNo || "NA",
        "Client Name": item?.customer?.name || "NA",
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA",
        "Design SignOff Date": item?.customerDesignSignOffDate ? moment(item.customerDesignSignOffDate).format('DD-MM-YYYY') : "NA",
        "Due Amount": formatAmount(item?.dueAmount || 0),
        "Possession Status": item?.propertyPossession || "NA",
        "Possession Date": item?.propertyPossessionDate ? moment(item.propertyPossessionDate).format('DD-MM-YYYY') : "NA",
        "Key Status": item?.hasKeys || "NA",
        "Expected Payment Date": item?.expectedPaymentDate ? moment(item.expectedPaymentDate).format('DD-MM-YYYY') : "NA",
        "Executive Name": item?.crmUser?.name || item?.CrmUsersname || 'NA',
      }));
      downloadExcel(data, headers, "dso-second-condition.xlsx", (row) => row);
    } catch (error) {
      console.error("Error downloading Second DSO Excel:", error);
      props.setSnackInfo?.("Couldn't prepare Excel export", "error");
    }
    setLoading(false);
  };

  const handleThirdDsoExcelDownload = async () => {
    setLoading(true);
    try {
      const response = await HttpService.DsoPaymentNotCollectedThirdCondition({ limit: -1, ...buildServerFilterParams(thirdDsoDebouncedFilters) });
      const headers = ["S.No", "Project No", "Client Name", "Contact", "Location", "Current Stage", "Design SignOff Date", "Due Amount", "Key Status", "Payment Date", "Expected Payment Date", "Executive Name"];
      const data = (response?.data?.data || []).map((item, idx) => ({
        "S.No": idx + 1,
        "Project No": item.erpProjectNo || "NA",
        "Client Name": item?.customer?.name || "NA",
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA",
        "Design SignOff Date": item?.customerDesignSignOffDate ? moment(item.customerDesignSignOffDate).format('DD-MM-YYYY') : "NA",
        "Due Amount": formatAmount(item?.dueAmount || 0),
        "Key Status": item?.hasKeys || "NA",
        "Payment Date": item?.materialDeliveryDate ? moment(item.materialDeliveryDate).format('DD-MM-YYYY') : 'NA',
        "Expected Payment Date": item?.expectedPaymentDate ? moment(item.expectedPaymentDate).format('DD-MM-YYYY') : "NA",
        "Executive Name": item?.crmUser?.name || item?.CrmUsersname || 'NA',
      }));
      downloadExcel(data, headers, "dso-third-condition.xlsx", (row) => row);
    } catch (error) {
      console.error("Error downloading Third DSO Excel:", error);
      props.setSnackInfo?.("Couldn't prepare Excel export", "error");
    }
    setLoading(false);
  };

  // NEW: Other DSO Excel Download Handler
  const handleOtherDsoExcelDownload = async () => {
    setLoading(true);
    try {
      const response = await HttpService.DsoPaymentNotCollectedOtherCondition({ limit: -1, ...buildServerFilterParams(otherDsoDebouncedFilters) });
      const headers = ["S.No", "Project No", "Client Name", "Contact", "Location", "Current Stage", "Design SignOff Date", "Due Amount", "Possession Status","Possession Date", "Key Status", "Material Delivery Willing", "Expected Payment Date", "Executive Name"];
      const data = (response?.data?.data || []).map((item, idx) => ({
        "S.No": idx + 1,
        "Project No": item.erpProjectNo || "NA",
        "Client Name": item?.customer?.name || "NA",
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA",
        "Design SignOff Date": item?.customerDesignSignOffDate ? moment(item.customerDesignSignOffDate).format('DD-MM-YYYY') : "NA",
        "Due Amount": formatAmount(item?.dueAmount || 0),
        "Possession Status": item?.propertyPossession || "NA",
        "Possession Date": item?.propertyPossessionDate  ? moment(item.propertyPossessionDate).format('DD-MM-YYYY') : "NA",
        "Key Status": item?.hasKeys || "NA",
        "Material Delivery Willing": item?.materialDeliveryWilling || "NA",
        "Expected Payment Date": item?.expectedPaymentDate ? moment(item.expectedPaymentDate).format('DD-MM-YYYY') : "NA",
        "Executive Name": item?.crmUser?.name || item?.CrmUsersname || 'NA',
      }));
      downloadExcel(data, headers, "dso-other-conditions.xlsx", (row) => row);
    } catch (error) {
      console.error("Error downloading Other DSO Excel:", error);
      props.setSnackInfo?.("Couldn't prepare Excel export", "error");
    }
    setLoading(false);
  };

  const handlePaymentExcelDownload = async () => {
    setLoading(true);
    try {
      const response = await HttpService.PaymentCollectedNotinUnderExecution({ limit: -1, ...buildServerFilterParams(paymentDebouncedFilters) });
      const headers = ["S.No", "Project No", "Lead No.", "Client Name", "Contact", "Location", "Current Stage", "Collected Amount", "Payment Collection Date", "Pending Days", "Expected Material Date", "Remark", "Executive Name"];
      const data = (response?.data?.data || []).map((item, idx) => ({
        "S.No": idx + 1,
        "Project No": item.erpProjectNo || "NA",
        "Lead No.": item.lead_no || "NA",
        "Client Name": item?.customer?.name || "NA",
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA",
        "Collected Amount": formatAmount(item?.totalPaid || 0),
        "Payment Collection Date": item?.lastPaymentDate ? moment(item.lastPaymentDate).format('DD-MM-YYYY') : 'NA',
        "Pending Days": item?.pendingDays || 'NA',
        "Expected Material Date": item?.expectedmaterialDeliveryDate ? moment(item.expectedmaterialDeliveryDate).format('DD-MM-YYYY') : 'NA',
        "Remark": item?.remark || "NA",
        "Executive Name": item?.crmUser?.name || item?.CrmUsersname || 'NA',
      }));
      downloadExcel(data, headers, "payment-collected.xlsx", (row) => row);
    } catch (error) {
      console.error("Error downloading Payment Excel:", error);
      props.setSnackInfo?.("Couldn't prepare Excel export", "error");
    }
    setLoading(false);
  };

  const handleUpdatedPaymentExcelDownload = async () => {
    setLoading(true);
    try {
      const response = await HttpService.getUpdatePaymentDate({ limit: -1, ...buildServerFilterParams(updatedPaymentDebouncedFilters) });
      const headers = ["S.No", "Project No", "Lead No.", "Client Name", "Contact", "Location", "Current Stage", "Expected Payment Date", "Due Amount", "Last Communication", "Latest Notes", "Executive Name"];
      const data = (response?.data?.data || []).map((item, idx) => ({
        "S.No": idx + 1,
        "Project No": item.erpProjectNo || "NA",
        "Lead No.": item.lead_no || "NA",
        "Client Name": item?.customer?.name || "NA",
        "Location": item?.cityName || "NA",
        "Current Stage": item?.currentStage || "NA",
        "Expected Payment Date": item?.expectedPaymentDate ? moment(item.expectedPaymentDate).format('DD-MM-YYYY') : "NA",
        "Due Amount": formatAmount(item?.dueAmount || 0),
        "Last Communication": item?.lastCommunicationDate ? moment(item.lastCommunicationDate).format('DD-MM-YYYY') : 'NA',
        "Latest Notes": item?.recentNote?.notes || 'NA',
        "Executive Name": item?.assignToCrmUser?.name || 'NA',
      }));
      downloadExcel(data, headers, "updated-payment-date.xlsx", (row) => row);
    } catch (error) {
      console.error("Error downloading Updated Payment Excel:", error);
      props.setSnackInfo?.("Couldn't prepare Excel export", "error");
    }
    setLoading(false);
  };

  // Render Main Filter Section
  const renderMainFilterSection = () => {
    return (
      <div className={classes.mainFilterContainer}>
        <Typography variant="h6" style={{ marginBottom: '16px', color: '#1C375D' }}>Executive Summary Filters</Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              size="small"
              label="From Date"
              type="date"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={tempFilters.fromDate}
              onChange={(e) => handleTempFilterChange('fromDate', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              fullWidth
              size="small"
              label="To Date"
              type="date"
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              value={tempFilters.toDate}
              onChange={(e) => handleTempFilterChange('toDate', e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Executive Name</InputLabel>
              <Select value={selectedExecutive} onChange={(e) => handleExecutiveFilterChange(e.target.value)} label="Executive Name (Frontend Filter)">
                <MenuItem value="">All Executives</MenuItem>
                {filterOptions.executives.map(exec => <MenuItem key={exec} value={exec}>{exec}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Box className={classes.filterActions}>
              <Button variant="contained" style={{ backgroundColor: '#1C375D', color: 'white' }} startIcon={<RefreshIcon />} onClick={applyFilters} size="small">
                Apply Filters
              </Button>
              <Button variant="outlined" color="secondary" startIcon={<ClearIcon />} onClick={clearMainFilters} size="small">
                Clear All Filters
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  };

  // Render Common Filter Section for Tables
  const renderCommonFilters = (filters, setFilters, clearFilters, showDueAmount = false, showDateFilter = false, dateLabel = "Date", dataSource = []) => {
    const locations = [...new Set(dataSource.map(item => item?.cityName).filter(loc => loc && loc !== 'NA'))];
    const stages = [...new Set(dataSource.map(item => item?.currentStage).filter(stage => stage && stage !== 'NA'))];
    // "Updated Expected Payment Date" rows carry the assigned executive as `assignToCrmUser`
    // (populated by getUpdatePaymentDate), not `crmUser`/`CrmUsersname` like the other 5 tables —
    // without this fallback the Executive Name dropdown was always empty on that table.
    const executives = [...new Set(dataSource.map(item => item?.crmUser?.name || item?.CrmUsersname || item?.assignToCrmUser?.name).filter(exec => exec && exec !== 'NA'))];
    
    return (
      <div className={classes.filterContainer}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={3}>
            <TextField fullWidth size="small" label="Project No" variant="outlined" value={filters.projectNo} onChange={(e) => setFilters({ ...filters, projectNo: e.target.value })} />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Location</InputLabel>
              <Select value={filters.location} onChange={(e) => setFilters({ ...filters, location: e.target.value })} label="Location">
                <MenuItem value="">All</MenuItem>
                {locations.map(loc => <MenuItem key={loc} value={loc}>{loc}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Current Stage</InputLabel>
              <Select value={filters.currentStage} onChange={(e) => setFilters({ ...filters, currentStage: e.target.value })} label="Current Stage">
                <MenuItem value="">All</MenuItem>
                {stages.map(stage => <MenuItem key={stage} value={stage}>{stage}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel>Executive Name</InputLabel>
              <Select value={filters.executiveName} onChange={(e) => setFilters({ ...filters, executiveName: e.target.value })} label="Executive Name">
                <MenuItem value="">All</MenuItem>
                {executives.map(exec => <MenuItem key={exec} value={exec}>{exec}</MenuItem>)}
              </Select>
            </FormControl>
          </Grid>
          {showDueAmount && (
            <>
              <Grid item xs={12} sm={6} md={3}>
                <TextField fullWidth size="small" label="Min Due Amount" type="number" variant="outlined" value={filters.minDueAmount} onChange={(e) => setFilters({ ...filters, minDueAmount: e.target.value })} />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField fullWidth size="small" label="Max Due Amount" type="number" variant="outlined" value={filters.maxDueAmount} onChange={(e) => setFilters({ ...filters, maxDueAmount: e.target.value })} />
              </Grid>
            </>
          )}
          {showDateFilter && (
            <>
              <Grid item xs={12} sm={6} md={3}>
                <TextField fullWidth size="small" label={`Start ${dateLabel}`} type="date" variant="outlined" InputLabelProps={{ shrink: true }} value={filters.startDate} onChange={(e) => setFilters({ ...filters, startDate: e.target.value })} />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <TextField fullWidth size="small" label={`End ${dateLabel}`} type="date" variant="outlined" InputLabelProps={{ shrink: true }} value={filters.endDate} onChange={(e) => setFilters({ ...filters, endDate: e.target.value })} />
              </Grid>
            </>
          )}
          <Grid item xs={12}>
            <Box display="flex" justifyContent="flex-end">
              <Button size="small" variant="contained" color="secondary" startIcon={<ClearIcon />} onClick={clearFilters}>
                Clear Filters
              </Button>
            </Box>
          </Grid>
        </Grid>
      </div>
    );
  };

  // NEW: Render Other DSO Filter Section
  const renderOtherDsoFilterSection = () => {
    return renderCommonFilters(otherDsoFilters, setOtherDsoFilters, clearOtherDsoFilters, true, false, "", tableFilterOptionRows.otherDso);
  };

  return (
    <div className={classes.root}>
      <Typography variant="h4" className={classes.title}>RFD Manager Dashboard</Typography>
      {/* Refresh Button */}
      <Box display="flex" justifyContent="flex-end" mt={2} mb={2}>
        <Button variant="contained" className={classes.refreshButton} startIcon={<RefreshIcon />} onClick={refreshAllData}>Refresh All Data</Button>
      </Box>

      {/* Main Filters Section */}
      {renderMainFilterSection()}

      {/* DASHBOARD 1: Executive Summary - Only Counts Clickable */}
      <div className={classes.tableContainer}>
        <div className={classes.sectionTitle}>1. EXECUTIVE SUMMARY - DSO PAYMENT STATUS</div>
        {loading.summary ? <div className={classes.loadingContainer}><CircularProgress /></div> : (
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.headerCell}>Executive Name</TableCell>
                  <TableCell className={classes.headerCell}>Total Projects (DSO Payment Not Collected)</TableCell>
                  <TableCell className={classes.headerCell}>Payment Collected Not in Under Execution</TableCell>
                  <TableCell className={classes.headerCell}>Total Due Amount</TableCell>
                  <TableCell className={classes.headerCell}>Collected Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredExecutiveSummaryData.length > 0 ? (
                  filteredExecutiveSummaryData.map((row, idx) => (
                    <TableRow key={idx} className={idx % 2 === 0 ? classes.tableRowEven : classes.tableRowOdd}>
                      <TableCell className={classes.tablecell}>{row.executiveName}</TableCell>
                      <TableCell
                        className={classes.clickableCount}
                        onClick={() => handleSummaryCountClick(row.executiveName, "Total Projects (DSO Payment Not Collected)", row)}>
                        {row.totalProjects}
                      </TableCell>
                      <TableCell
                        className={classes.clickableCount}
                        onClick={() => handleSummaryCountClick(row.executiveName, "Payment Collected Not in Under Execution", row)}>
                        {row.paymentCollectedNotInExecution}
                      </TableCell>
                      <TableCell className={classes.tablecell}>{formatAmount(row.totalDueAmount)}</TableCell>
                      <TableCell className={classes.tablecell}>{formatAmount(row.collectedAmount)}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} className={classes.tablecell} style={{ textAlign: 'center' }}>
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>

      {/* DASHBOARD 2: Executive Daily Work Status with Grand Total Row */}
      <div className={classes.tableContainer}>
        <div className={classes.sectionTitle}>2. EXECUTIVE DAILY WORK STATUS (Today's Data)</div>
        {loading.workStatus ? <div className={classes.loadingContainer}><CircularProgress /></div> : (
          <TableContainer component={Paper}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.headerCell}>Executive Name</TableCell>
                  <TableCell className={classes.headerCell}>Assigned Projects (Yesterday Signoff)</TableCell>
                  <TableCell className={classes.headerCell}>Pending Projects</TableCell>
                  <TableCell className={classes.headerCell}>Today's Due Amount</TableCell>
                  <TableCell className={classes.headerCell}>Today's Collected Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredExecutiveWorkStatusData.length > 0 ? (
                  <>
                    {filteredExecutiveWorkStatusData.map((row, idx) => (
                      <TableRow key={idx} className={idx % 2 === 0 ? classes.tableRowEven : classes.tableRowOdd}>
                        <TableCell className={classes.tablecell}>{row.executiveName}</TableCell>
                        <TableCell
                          className={classes.clickableCount}
                          onClick={() => handleWorkStatusClick(row.executiveName, "Assigned Projects", row)}>
                          {row.yesterdaySignoffCount || 0}
                        </TableCell>
                        <TableCell
                          className={classes.clickableCount}
                          onClick={() => handleWorkStatusClick(row.executiveName, "Pending Projects", row)}>
                          {row.pendingProjects}
                        </TableCell>
                        <TableCell
                          className={classes.clickableCount}
                          onClick={() => handleWorkStatusClick(row.executiveName, "Today's Due Amount", row)}>
                          {formatAmount(row.todayDueAmount)}
                        </TableCell>
                        <TableCell
                          className={classes.clickableCount}
                          onClick={() => handleWorkStatusClick(row.executiveName, "Today's Collected Amount", row)}>
                          {formatAmount(row.todayCollectedAmount)}
                        </TableCell>
                      </TableRow>
                    ))}
                    {/* Grand Total Row */}
                    {workStatusGrandTotals && (
                      <TableRow className={classes.grandTotalRow}>
                        <TableCell className={classes.tablecell} style={{ fontWeight: 'bold', backgroundColor: '#e8f0fe' }}>
                          GRAND TOTAL
                        </TableCell>
                        <TableCell className={classes.tablecell} style={{ fontWeight: 'bold', backgroundColor: '#e8f0fe' }}>
                          {workStatusGrandTotals.totalYesterdaySignoffs || workStatusGrandTotals.totalAssignedProjects || 0}
                        </TableCell>
                        <TableCell className={classes.tablecell} style={{ fontWeight: 'bold', backgroundColor: '#e8f0fe' }}>
                          {workStatusGrandTotals.totalPendingProjects || 0}
                        </TableCell>
                        <TableCell className={classes.tablecell} style={{ fontWeight: 'bold', backgroundColor: '#e8f0fe' }}>
                          {formatAmount(workStatusGrandTotals.totalTodayExpectedAmount || 0)}
                        </TableCell>
                        <TableCell className={classes.tablecell} style={{ fontWeight: 'bold', backgroundColor: '#e8f0fe' }}>
                          {formatAmount(workStatusGrandTotals.totalTodayCollectedAmount || 0)}
                        </TableCell>
                      </TableRow>
                    )}
                  </>
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} className={classes.tablecell} style={{ textAlign: 'center' }}>
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>

      {/* DASHBOARD 3: Yes DSO - Table 1 */}
      <div className={classes.tableContainer}>
        <div className={classes.sectionTitle}>3. DSO - PAYMENT NOT COLLECTED</div>
        <div className={classes.subNote}>Condition: Possession(Yes), Keys(Yes), Material Delivery Willing(Yes)</div>
        {loading.yesDso ? <div className={classes.loadingContainer}><CircularProgress /></div> : (
          <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              {renderFilterToggle(showYesDsoFilters, setShowYesDsoFilters, '')}
              <Button variant="contained" className={classes.downloadButton} startIcon={<RiFileExcel2Fill />} onClick={handleYesDsoExcelDownload}>Download Excel</Button>
            </Box>
            {showYesDsoFilters && renderCommonFilters(yesDsoFilters, setYesDsoFilters, clearYesDsoFilters, true, false, "", tableFilterOptionRows.yesDso)}
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.headerCell}>S.No</TableCell>
                    <TableCell className={classes.headerCell}>Project No</TableCell>
                    <TableCell className={classes.headerCell}>Client Name</TableCell>
                    <TableCell className={classes.headerCell}>Contact</TableCell>
                    <TableCell className={classes.headerCell}>Location</TableCell>
                    <TableCell className={classes.headerCell}>Current Stage</TableCell>
                    <TableCell className={classes.headerCell}>Design SignOff Date</TableCell>
                    <TableCell className={classes.headerCell}>Due Amount</TableCell>
                    <TableCell className={classes.headerCell}>Expected Payment Date</TableCell>
                    <TableCell className={classes.headerCell}>Executive Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredYesDso.map((row, idx) => (
                    <TableRow key={row._id || idx}>
                      <TableCell className={classes.tablecell}>{yesDsoPage * yesDsoRowsPerPage + idx + 1}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <span className={classes.projectLink} onClick={() => handleProjectClick(row?._id)}>
                          {row?.erpProjectNo || 'NA'}
                        </span>
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.name || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.contact_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        {row?.customerDesignSignOffDate ? moment(row.customerDesignSignOffDate).format('DD-MM-YYYY') : 'NA'}
                      </TableCell>
                      <TableCell className={classes.amountCell}>{formatAmount(row?.dueAmount || 0)}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableDateCell 
                          tableKey="yesDso"
                          date={row?.expectedPaymentDate} 
                          projectId={row._id} 
                          fieldName="expectedPaymentDate"
                          label="Payment Date"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.crmUser?.name || row?.CrmUsersname || 'NA'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination 
                      rowsPerPageOptions={[10, 25, 50, { label: 'All', value: tableTotalCounts.yesDso || 1 }]}
                      colSpan={10}
                      count={tableTotalCounts.yesDso}
                      rowsPerPage={yesDsoRowsPerPage}
                      page={yesDsoPage} 
                      onPageChange={handleYesDsoPageChange} 
                      onRowsPerPageChange={handleYesDsoRowsPerPageChange} 
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </>
        )}
      </div>

      {/* DASHBOARD 4: Second DSO - Table 2 */}
      <div className={classes.tableContainer}>
        <div className={classes.subNote}>Condition: Possession(No), Keys(No), Material Delivery Willing(Yes)</div>
        {loading.secondDso ? <div className={classes.loadingContainer}><CircularProgress /></div> : (
          <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              {renderFilterToggle(showSecondDsoFilters, setShowSecondDsoFilters, '')}
              <Button variant="contained" className={classes.downloadButton} startIcon={<RiFileExcel2Fill />} onClick={handleSecondDsoExcelDownload}>Download Excel</Button>
            </Box>
            {showSecondDsoFilters && renderCommonFilters(secondDsoFilters, setSecondDsoFilters, clearSecondDsoFilters, true, true, "Possession Date", tableFilterOptionRows.secondDso)}
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.headerCell}>S.No</TableCell>
                    <TableCell className={classes.headerCell}>Project No</TableCell>
                    <TableCell className={classes.headerCell}>Client Name</TableCell>
                    <TableCell className={classes.headerCell}>Contact</TableCell>
                    <TableCell className={classes.headerCell}>Location</TableCell>
                    <TableCell className={classes.headerCell}>Current Stage</TableCell>
                    <TableCell className={classes.headerCell}>Design SignOff Date</TableCell>
                    <TableCell className={classes.headerCell}>Due Amount</TableCell>
                    <TableCell className={classes.headerCell}>Possession Status</TableCell>
                    <TableCell className={classes.headerCell}>Possession Date</TableCell>
                    <TableCell className={classes.headerCell}>Key Status</TableCell>
                    <TableCell className={classes.headerCell}>Expected Payment Date</TableCell>
                    <TableCell className={classes.headerCell}>Executive Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredSecondDso.map((row, idx) => (
                    <TableRow key={row._id || idx}>
                      <TableCell className={classes.tablecell}>{secondDsoPage * secondDsoRowsPerPage + idx + 1}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <span className={classes.projectLink} onClick={() => handleProjectClick(row?._id)}>
                          {row?.erpProjectNo || 'NA'}
                        </span>
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.name || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.contact_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        {row?.customerDesignSignOffDate ? moment(row.customerDesignSignOffDate).format('DD-MM-YYYY') : 'NA'}
                      </TableCell>
                      <TableCell className={classes.amountCell}>{formatAmount(row?.dueAmount || 0)}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableSelectCell 
                          tableKey="secondDso"
                          value={row?.propertyPossession} 
                          options={['Yes', 'No']}
                          projectId={row._id} 
                          fieldName="propertyPossession"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableDateCell 
                          tableKey="secondDso"
                          date={row?.propertyPossessionDate} 
                          projectId={row._id} 
                          fieldName="propertyPossessionDate"
                          label="Possession Date"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableSelectCell 
                          tableKey="secondDso"
                          value={row?.hasKeys} 
                          options={['Yes', 'No']}
                          projectId={row._id} 
                          fieldName="hasKeys"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableDateCell 
                          tableKey="secondDso"
                          date={row?.expectedPaymentDate} 
                          projectId={row._id} 
                          fieldName="expectedPaymentDate"
                          label="Payment Date"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.crmUser?.name || row?.CrmUsersname || 'NA'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination 
                      rowsPerPageOptions={[10, 25, 50, { label: 'All', value: tableTotalCounts.secondDso || 1 }]}
                      colSpan={13}
                      count={tableTotalCounts.secondDso}
                      rowsPerPage={secondDsoRowsPerPage}
                      page={secondDsoPage} 
                      onPageChange={handleSecondDsoPageChange} 
                      onRowsPerPageChange={handleSecondDsoRowsPerPageChange} 
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </>
        )}
      </div>

      {/* DASHBOARD 5: Third DSO - Table 3 */}
      <div className={classes.tableContainer}>
        <div className={classes.subNote}>Condition: Possession(Yes), Keys(No), Material Delivery Willing(No)</div>
        {loading.thirdDso ? <div className={classes.loadingContainer}><CircularProgress /></div> : (
          <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              {renderFilterToggle(showThirdDsoFilters, setShowThirdDsoFilters, '')}
              <Button variant="contained" className={classes.downloadButton} startIcon={<RiFileExcel2Fill />} onClick={handleThirdDsoExcelDownload}>Download Excel</Button>
            </Box>
            {showThirdDsoFilters && renderCommonFilters(thirdDsoFilters, setThirdDsoFilters, clearThirdDsoFilters, true, false, "", tableFilterOptionRows.thirdDso)}
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.headerCell}>S.No</TableCell>
                    <TableCell className={classes.headerCell}>Project No</TableCell>
                    <TableCell className={classes.headerCell}>Client Name</TableCell>
                    <TableCell className={classes.headerCell}>Contact</TableCell>
                    <TableCell className={classes.headerCell}>Location</TableCell>
                    <TableCell className={classes.headerCell}>Current Stage</TableCell>
                    <TableCell className={classes.headerCell}>Design SignOff Date</TableCell>
                    <TableCell className={classes.headerCell}>Due Amount</TableCell>
                    <TableCell className={classes.headerCell}>Key Status</TableCell>
                    <TableCell className={classes.headerCell}>Payment Date</TableCell>
                    <TableCell className={classes.headerCell}>Expected Payment Date</TableCell>
                    <TableCell className={classes.headerCell}>Executive Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredThirdDso.map((row, idx) => (
                    <TableRow key={row._id || idx}>
                      <TableCell className={classes.tablecell}>{thirdDsoPage * thirdDsoRowsPerPage + idx + 1}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <span className={classes.projectLink} onClick={() => handleProjectClick(row?._id)}>
                          {row?.erpProjectNo || 'NA'}
                        </span>
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.name || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.contact_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        {row?.customerDesignSignOffDate ? moment(row.customerDesignSignOffDate).format('DD-MM-YYYY') : 'NA'}
                      </TableCell>
                      <TableCell className={classes.amountCell}>{formatAmount(row?.dueAmount || 0)}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableSelectCell 
                          tableKey="thirdDso"
                          value={row?.hasKeys} 
                          options={['Yes', 'No']}
                          projectId={row._id} 
                          fieldName="hasKeys"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                      {row?.materialDeliveryDate ? moment(row.materialDeliveryDate).format('DD-MM-YYYY') : 'NA'}
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableDateCell 
                          tableKey="thirdDso"
                          date={row?.expectedPaymentDate} 
                          projectId={row._id} 
                          fieldName="expectedPaymentDate"
                          label="Payment Date"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.crmUser?.name || row?.CrmUsersname || 'NA'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination 
                      rowsPerPageOptions={[10, 25, 50, { label: 'All', value: tableTotalCounts.thirdDso || 1 }]}
                      colSpan={12}
                      count={tableTotalCounts.thirdDso}
                      rowsPerPage={thirdDsoRowsPerPage} 
                      page={thirdDsoPage} 
                      onPageChange={handleThirdDsoPageChange} 
                      onRowsPerPageChange={handleThirdDsoRowsPerPageChange} 
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </>
        )}
      </div>

      {/* NEW DASHBOARD 6: Other DSO - Table 4 */}
      <div className={classes.tableContainer}>
        <div className={classes.subNote}>Additional conditions</div>
        {loading.otherDso ? <div className={classes.loadingContainer}><CircularProgress /></div> : (
          <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              {renderFilterToggle(showOtherDsoFilters, setShowOtherDsoFilters, '')}
              <Button variant="contained" className={classes.downloadButton} startIcon={<RiFileExcel2Fill />} onClick={handleOtherDsoExcelDownload}>Download Excel</Button>
            </Box>
            {showOtherDsoFilters && renderOtherDsoFilterSection()}
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.headerCell}>S.No</TableCell>
                    <TableCell className={classes.headerCell}>Project No</TableCell>
                    <TableCell className={classes.headerCell}>Client Name</TableCell>
                    <TableCell className={classes.headerCell}>Contact</TableCell>
                    <TableCell className={classes.headerCell}>Location</TableCell>
                    <TableCell className={classes.headerCell}>Current Stage</TableCell>
                    <TableCell className={classes.headerCell}>Design SignOff Date</TableCell>
                    <TableCell className={classes.headerCell}>Due Amount</TableCell>
                    <TableCell className={classes.headerCell}>Possession Status</TableCell>
                    <TableCell className={classes.headerCell}>Possession Date</TableCell>
                    <TableCell className={classes.headerCell}>Key Status</TableCell>
                    <TableCell className={classes.headerCell}>Material Delivery Willing</TableCell>
                    <TableCell className={classes.headerCell}>Expected Payment Date</TableCell>
                    <TableCell className={classes.headerCell}>Executive Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredOtherDso.map((row, idx) => (
                    <TableRow key={row._id || idx}>
                      <TableCell className={classes.tablecell}>{otherDsoPage * otherDsoRowsPerPage + idx + 1}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <span className={classes.projectLink} onClick={() => handleProjectClick(row?._id)}>
                          {row?.erpProjectNo || 'NA'}
                        </span>
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.name || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.contact_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        {row?.customerDesignSignOffDate ? moment(row.customerDesignSignOffDate).format('DD-MM-YYYY') : 'NA'}
                      </TableCell>
                      <TableCell className={classes.amountCell}>{formatAmount(row?.dueAmount || 0)}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableSelectCell 
                          tableKey="otherDso"
                          value={row?.propertyPossession} 
                          options={['Yes', 'No']}
                          projectId={row._id} 
                          fieldName="propertyPossession"
                        />
                      </TableCell>
                        <TableCell className={classes.tablecell}>
                                              <EditableDateCell 
                                                tableKey="otherDso"
                                                date={row?.propertyPossessionDate} 
                                                projectId={row._id} 
                                                fieldName="propertyPossessionDate"
                                                label="Possession Date"
                                              />
                                            </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableSelectCell 
                          tableKey="otherDso"
                          value={row?.hasKeys} 
                          options={['Yes', 'No']}
                          projectId={row._id} 
                          fieldName="hasKeys"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableSelectCell 
                          tableKey="otherDso"
                          value={row?.materialDeliveryWilling} 
                          options={['Yes', 'No']}
                          projectId={row._id} 
                          fieldName="materialDeliveryWilling"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableDateCell 
                          tableKey="otherDso"
                          date={row?.expectedPaymentDate} 
                          projectId={row._id} 
                          fieldName="expectedPaymentDate"
                          label="Payment Date"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.crmUser?.name || row?.CrmUsersname || 'NA'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination 
                      rowsPerPageOptions={[10, 25, 50, { label: 'All', value: tableTotalCounts.otherDso || 1 }]}
                      colSpan={13}
                      count={tableTotalCounts.otherDso}
                      rowsPerPage={otherDsoRowsPerPage}
                      page={otherDsoPage} 
                      onPageChange={handleOtherDsoPageChange} 
                      onRowsPerPageChange={handleOtherDsoRowsPerPageChange} 
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </>
        )}
      </div>

      {/* DASHBOARD 7: Payment Collected Not in Under Execution */}
      <div className={classes.tableContainer}>
        <div className={classes.sectionTitle}>4. PAYMENT COLLECTED NOT IN UNDER EXECUTION</div>
        <div className={classes.subNote}>Projects where payment has been collected but not moved to under execution stage</div>
        {loading.payment ? <div className={classes.loadingContainer}><CircularProgress /></div> : (
          <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              {renderFilterToggle(showPaymentFilters, setShowPaymentFilters, '')}
              <Button variant="contained" className={classes.downloadButton} startIcon={<RiFileExcel2Fill />} onClick={handlePaymentExcelDownload}>Download Excel</Button>
            </Box>
            {showPaymentFilters && renderCommonFilters(paymentFilters, setPaymentFilters, clearPaymentFilters, false, false, "", tableFilterOptionRows.payment)}
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.headerCell}>S.No</TableCell>
                    <TableCell className={classes.headerCell}>Project No</TableCell>
                    <TableCell className={classes.headerCell}>Lead No.</TableCell>
                    <TableCell className={classes.headerCell}>Client Name</TableCell>
                    <TableCell className={classes.headerCell}>Contact</TableCell>
                    <TableCell className={classes.headerCell}>Location</TableCell>
                    <TableCell className={classes.headerCell}>Current Stage</TableCell>
                    <TableCell className={classes.headerCell}>Collected Amount</TableCell>
                    <TableCell className={classes.headerCell}>Payment Collection Date</TableCell>
                    <TableCell className={classes.headerCell}>Pending Days</TableCell>
                    <TableCell className={classes.headerCell}>Expected Material Date</TableCell>
                    <TableCell className={classes.headerCell}>Remark</TableCell>
                    <TableCell className={classes.headerCell}>Executive Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredPayment.map((row, idx) => (
                    <TableRow key={row._id || idx}>
                      <TableCell className={classes.tablecell}>{paymentPage * paymentRowsPerPage + idx + 1}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <span className={classes.projectLink} onClick={() => handleProjectClick(row?._id)}>
                          {row?.erpProjectNo || 'NA'}
                        </span>
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.lead_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.name || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.contact_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{formatAmount(row?.totalPaid || 0)}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.lastPaymentDate ? moment(row.lastPaymentDate).format('DD-MM-YYYY') : 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.pendingDays || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableDateCell 
                          tableKey="payment"
                          date={row?.expectedmaterialDeliveryDate} 
                          projectId={row._id} 
                          fieldName="expectedmaterialDeliveryDate"
                          label="Material Delivery Date"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>
                        <EditableTextCell 
                          tableKey="payment"
                          value={row?.remark} 
                          projectId={row._id} 
                          fieldName="remark"
                        />
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.crmUser?.name || row?.CrmUsersname || 'NA'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination 
                      rowsPerPageOptions={[10, 25, 50, { label: 'All', value: tableTotalCounts.payment || 1 }]}
                      colSpan={13}
                      count={tableTotalCounts.payment}
                      rowsPerPage={paymentRowsPerPage} 
                      page={paymentPage} 
                      onPageChange={handlePaymentPageChange} 
                      onRowsPerPageChange={handlePaymentRowsPerPageChange} 
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </>
        )}
      </div>

      {/* DASHBOARD 8: Updated Expected Payment Date */}
      <div className={classes.tableContainer}>
        <div className={classes.sectionTitle}>5. UPDATED EXPECTED PAYMENT DATE</div>
        <div className={classes.subNote}>Projects with updated expected payment date</div>
        {loading.updatedPayment ? <div className={classes.loadingContainer}><CircularProgress /></div> : (
          <>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              {renderFilterToggle(showUpdatedPaymentFilters, setShowUpdatedPaymentFilters, '')}
              <Button variant="contained" className={classes.downloadButton} startIcon={<RiFileExcel2Fill />} onClick={handleUpdatedPaymentExcelDownload}>Download Excel</Button>
            </Box>
            {showUpdatedPaymentFilters && renderCommonFilters(updatedPaymentFilters, setUpdatedPaymentFilters, clearUpdatedPaymentFilters, false, true, "Expected Date", tableFilterOptionRows.updatedPayment)}
            <TableContainer component={Paper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.headerCell}>S.No</TableCell>
                    <TableCell className={classes.headerCell}>Project No</TableCell>
                    <TableCell className={classes.headerCell}>Lead No.</TableCell>
                    <TableCell className={classes.headerCell}>Client Name</TableCell>
                    <TableCell className={classes.headerCell}>Contact</TableCell>
                    <TableCell className={classes.headerCell}>Location</TableCell>
                    <TableCell className={classes.headerCell}>Current Stage</TableCell>
                    <TableCell className={classes.headerCell}>Expected Payment Date</TableCell>
                    <TableCell className={classes.headerCell}>Due Amount</TableCell>
                    <TableCell className={classes.headerCell}>Last Communication</TableCell>
                    <TableCell className={classes.headerCell}>Latest Notes</TableCell>
                    <TableCell className={classes.headerCell}>Executive Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredUpdatedPayment.map((row, idx) => (
                    <TableRow key={row._id || idx}>
                      <TableCell className={classes.tablecell}>{updatedPaymentPage * updatedPaymentRowsPerPage + idx + 1}</TableCell>
                      <TableCell className={classes.tablecell}>
                        <span className={classes.projectLink} onClick={() => handleProjectClick(row?._id)}>
                          {row?.erpProjectNo || 'NA'}
                        </span>
                      </TableCell>
                      <TableCell className={classes.tablecell}>{row?.lead_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.name || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.customer?.contact_no || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.cityName || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.currentStage || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>
                      {row?.expectedPaymentDate ? moment(row.expectedPaymentDate).format('DD-MM-YYYY') : 'NA'}
                      </TableCell>
                      <TableCell className={classes.amountCell}>{formatAmount(row?.dueAmount || 0)}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.lastCommunicationDate ? moment(row.lastCommunicationDate).format('DD-MM-YYYY') : 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.recentNote?.notes || 'NA'}</TableCell>
                      <TableCell className={classes.tablecell}>{row?.assignToCrmUser?.name || 'NA'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination 
                      rowsPerPageOptions={[10, 25, 50, { label: 'All', value: tableTotalCounts.updatedPayment || 1 }]}
                      colSpan={12}
                      count={tableTotalCounts.updatedPayment}
                      rowsPerPage={updatedPaymentRowsPerPage} 
                      page={updatedPaymentPage} 
                      onPageChange={handleUpdatedPaymentPageChange} 
                      onRowsPerPageChange={handleUpdatedPaymentRowsPerPageChange} 
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </>
        )}
      </div>

      {/* Details Dialog for Drill-Down */}
      <Dialog open={showDetailsDialog} onClose={handleCloseDialog} maxWidth="xl" classes={{ paper: classes.dialogPaper }}>
        <DialogTitle className={classes.dialogTitle}>
          <Typography variant="h6">
            {selectedExecutiveName ? `${selectedMetric} Details for ${selectedExecutiveName}` : `${selectedMetric} Details`} ({selectedMetricData.length} Records)
          </Typography>
          <IconButton className={classes.closeButton} onClick={handleCloseDialog}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialogContent}>
          <div className={classes.paginationWrapper}>
            <Button variant="contained" className={classes.downloadButton} startIcon={<RiFileExcel2Fill />} onClick={handleDialogDownload}>Download Excel</Button>
            <TablePagination 
              rowsPerPageOptions={[10, 25, 50, 100]} 
              count={selectedMetricData.length} 
              rowsPerPage={dialogRowsPerPage} 
              page={dialogPage} 
              onPageChange={(e, p) => setDialogPage(p)} 
              onRowsPerPageChange={(e) => { setDialogRowsPerPage(parseInt(e.target.value)); setDialogPage(0); }} 
            />
          </div>
          {renderDialogContent()}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

ManagerDashboard.propTypes = {
  setLoading: PropTypes.func.isRequired,
  setSnackInfo: PropTypes.func.isRequired,
};

export default connect(null, { setLoading, setSnackInfo })(ManagerDashboard);